import React from "react";
import { HiOutlineCalendar } from "react-icons/hi";

import DoSeeListPage from "../../../layout/DoSeeListPage";
import { _TYPES_ } from "../utils/types";
import { pushOneEvent } from "../../../lib/sysNavigation/SysNavigation";

type EventRow = {
  event_id: number | string;
  title?: string;
  slug?: string;
  [key: string]: unknown;
};

const Overview: React.FC = () => (
  <DoSeeListPage<EventRow>
    type={_TYPES_.EVENT}
    title="Events"
    subtitle="Happenings promoted on the public site."
    icon={<HiOutlineCalendar className="h-5 w-5" />}
    addRoute="/data/event/add"
    editRoute="/data/event/edit"
    pushOne={pushOneEvent}
    dataKey="events"
    countKey="eventsCount"
    idField="event_id"
    titleField="title"
  />
);

export default Overview;
